import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: rem(3),
        width: "100%",
    },
}))
